















































import { editFactory } from '@/main/pages';
import { Dodavatel } from '@/modules/ciselnik/skladove/dodavatel';

import { editMutations } from './store/types';
import { store } from './store/edit';
import { NAME, GDPR_SOUHLAS_TXT } from './constants';

export default editFactory(NAME, store).extend({
	components: {
		DodavatelSelect: Dodavatel.components.Select,
	},
	data() {
		return {
			radioLabels: [
				{ value: GDPR_SOUHLAS_TXT.C1, text: this.Localize('GDPR_SOUHLAS_TXT_C1') },
				{ value: GDPR_SOUHLAS_TXT.C2, text: this.Localize('GDPR_SOUHLAS_TXT_C2') },
				{ value: GDPR_SOUHLAS_TXT.C3, text: this.Localize('GDPR_SOUHLAS_TXT_C3') },
			],
		};
	},
	computed: {
		mutationsMappers() {
			return {
				dodavatel: `${this.storeUri}/${editMutations.VYROBEK_VOZ_DODAVATEL_SELECT_MAPPER}`,
			};
		},
		richText(): string {
			switch (this.memType) {
				case GDPR_SOUHLAS_TXT.C1:
					return this.GdprSouhlasTxtC1;
				case GDPR_SOUHLAS_TXT.C2:
					return this.GdprSouhlasTxtC2;
				case GDPR_SOUHLAS_TXT.C3:
					return this.GdprSouhlasTxtC3;
				default: return '';
			}
		},
	},
});
